module.exports = __webpack_public_path__ + "img/check-circle-green.d9483f6e.svg";